import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ReportGmailerrorredRoundedIcon from '@mui/icons-material/ReportGmailerrorredRounded';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Button } from '@mui/material';
import React, { useCallback } from 'react';
import { useCreatorThemeContext } from '../../../../../features/Common/modules/Theme/CreatorThemeContext.js';
import { COMMENT_STATUS } from '../../../../../features/Offerings/modules/RecordedContent/CommentSection/CommentSection.data.js';
import Popover from '../../../../common/Popover/Popover.js';
import { getThemedStyles, styles } from './MoreButtonAndMenu.styles.js';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

var MoreButtonAndMenu = function (_a) {
    var MoreButtonComponent = _a.MoreButtonComponent, canEdit = _a.canEdit, onEditClick = _a.onEditClick, canDelete = _a.canDelete, onDeleteClick = _a.onDeleteClick, currentCommentStatus = _a.currentCommentStatus, canHideUnhide = _a.canHideUnhide, onHideUnhideClick = _a.onHideUnhideClick, canViewVoters = _a.canViewVoters, onViewVotes = _a.onViewVotes, canReport = _a.canReport, onReport = _a.onReport, canDuplicatePost = _a.canDuplicatePost, onDuplicatePostClick = _a.onDuplicatePostClick, _b = _a.deleteCtaText, deleteCtaText = _b === void 0 ? "Delete" : _b, _c = _a.reportCtaText, reportCtaText = _c === void 0 ? "Report post" : _c;
    if (!canEdit &&
        !canDelete &&
        !canHideUnhide &&
        !canViewVoters &&
        !canReport &&
        !canDuplicatePost)
        return null;
    var theme = useCreatorThemeContext();
    var themedStyles = getThemedStyles({ theme: theme });
    var isCurrentCommentHidden = currentCommentStatus == COMMENT_STATUS.HIDDEN;
    var AnchorComponent = useCallback(function (_a) {
        var openPopover = _a.openPopover;
        return (React.createElement(MoreButtonComponent, { className: styles.moreButton, onClick: openPopover, fontSize: "small" }));
    }, []);
    return (React.createElement(Popover, { AnchorComponent: AnchorComponent, PopoverComponent: function (_a) {
            var closePopover = _a.closePopover;
            var getClickHandler = function (callback) {
                return function (e) {
                    if (callback)
                        callback();
                    closePopover(e);
                };
            };
            var actions = [
                {
                    id: 1,
                    label: "Edit",
                    icon: React.createElement(EditOutlinedIcon, { className: themedStyles.editIcon }),
                    onClick: getClickHandler(onEditClick),
                    show: canEdit,
                },
                {
                    id: 2,
                    label: "Unhide",
                    icon: isCurrentCommentHidden ? (React.createElement(VisibilityOutlinedIcon, null)) : (React.createElement(VisibilityOffOutlinedIcon, null)),
                    onClick: getClickHandler(function () {
                        return onHideUnhideClick === null || onHideUnhideClick === void 0 ? void 0 : onHideUnhideClick({
                            status: isCurrentCommentHidden
                                ? COMMENT_STATUS.SHOWN
                                : COMMENT_STATUS.HIDDEN,
                        });
                    }),
                    show: canHideUnhide,
                },
                {
                    id: 3,
                    label: "View votes",
                    icon: React.createElement(BarChartRoundedIcon, null),
                    onClick: getClickHandler(onViewVotes),
                    show: canViewVoters,
                    className: themedStyles.votersCta,
                },
                {
                    id: 4,
                    label: "Duplicate post",
                    icon: React.createElement(ContentCopyIcon, null),
                    onClick: getClickHandler(onDuplicatePostClick),
                    show: canDuplicatePost,
                },
                {
                    id: 5,
                    label: reportCtaText,
                    icon: React.createElement(ReportGmailerrorredRoundedIcon, null),
                    onClick: getClickHandler(onReport),
                    show: canReport,
                    className: styles.reportCta,
                },
                {
                    id: 6,
                    label: deleteCtaText,
                    icon: React.createElement(DeleteRoundedIcon, null),
                    onClick: getClickHandler(onDeleteClick),
                    show: canDelete,
                    className: styles.deteleCta,
                },
            ].filter(function (cta) { return cta.show; });
            return (React.createElement("div", { className: styles.moreMenuContainer }, actions.map(function (_a, index) {
                var id = _a.id, icon = _a.icon, label = _a.label, className = _a.className, onClick = _a.onClick;
                return (React.createElement("div", { key: id },
                    index > 0 && React.createElement("div", { className: styles.divider }),
                    React.createElement(Button, { className: className, startIcon: icon, onClick: onClick, fullWidth: true }, label)));
            })));
        }, popoverProps: {
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "right",
            },
        } }));
};

export { MoreButtonAndMenu as default };
//# sourceMappingURL=MoreButtonAndMenu.js.map
